import React from 'react';
import { useHistory } from 'react-router-dom';

import './error-display-style.scss';

import Error404Img from '@src/imagesNew/icons/error-404.png';

import Button from '@src/componentsNew/Buttons/Button';
import Typography from '@src/componentsNew/Typography/Typography';

import { baseUrl } from '@src/app/routes';

const ErrorDisplay = () => {
  const history = useHistory();

  return (
    <article id="error-display">
      <img src={Error404Img} width={150} alt="error" />

      <div className="content-wrapper">
        <div className="text-wrapper">
          <Typography variant="h8" component="p" style={{ color: '#212121' }}>
            Oops, something went wrong!
          </Typography>
          <Typography variant="body2" component="p" style={{ color: '#666666' }}>
            Sorry for the inconvenience. Please try again.
          </Typography>
        </div>

        <Button cName="go-home-btn" variant="contained" size="large" onClick={() => history.push(baseUrl)}>
          Go To Home
        </Button>
      </div>
    </article>
  );
};

export default ErrorDisplay;
